module.exports = __webpack_public_path__ + "static/credit-card-4696f86c400b3d039ac18c003d41fa8a.png";